import Header from "../Home/Header";
import Footer from "../Home/Footer";
import Setting from './Setting';

const SettingMenu = () => {
  return (
 <>
      <Header />
      <Setting/>
      <Footer />
    </>  )
}

export default SettingMenu